
import { ResponsiveIframe } from '../layouts/ResponsiveIframe.js';

export const Form = {
  onLoad: function() {
    if ($('.template-form').length) {
      ResponsiveIframe.onLoad();
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/modules/Form.js